import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'components_v2/common/Dropdown/DropdownLoader';
import CardListV5 from 'components_v2/common/CardListV5/CardListV5';
import InterSectionBorder from 'components_v2/common/InterSectionBorder/InterSectionBorder';
import s from './RowLayoutWithVerticalColumns.scss';
import Listingheader from '../../common/ListingheaderV2';
import LinksList from '../../../../../components_v2/desktop/LinksList';
import HeaderTab from '../HeaderTabV2';

class RowLayoutWithVerticalColumns extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    if (this.state.hideMe) {
      // console.log('this.state.isParentNeedToHide is set to true');
      return null;
    }

    const { sectionData = { items: [] }, threeColumnView } = this.props;
    //const listItems = sectionData.data ? sectionData.data.items : [];
    const sectionName = sectionData.name;
    const scrollGAAttr = {
      ...(sectionData.onScrollGA &&
        sectionData.id && { 'data-scrollga': sectionData.id }),
    };

    return (
      <>
        <div className={s.section_wrapper} {...scrollGAAttr}>
          {sectionData.border &&
            sectionData.border === 'top' && (
              <InterSectionBorder border={sectionData.border} />
            )}
          {sectionName && sectionData.id ? (
            <Listingheader
              headingname={sectionName}
              headingLink={sectionData.link}
              newga={`${sectionName}Section_Actions#${sectionName}_HeadingClick`}
              target={sectionData.target}
              ga4Type={sectionData?.ga4Type}
              ga4Category={sectionData?.ga4Category}
            >
              {this.props.subSections &&
              this.props.subSections instanceof Array ? (
                <HeaderTab
                  subSections={this.props.subSections}
                  onChangeCallback={this.onTabsChange}
                  newga={`${sectionData.name}Section_Actions_TabChange#${
                    sectionData.name
                  }Click_`}
                  ga4Type={sectionData?.ga4Type}
                  ga4Category={sectionData?.ga4Category}
                />
              ) : (
                <Dropdown
                  data={
                    sectionData.navigation && sectionData.navigation.sections
                  }
                />
              )}
            </Listingheader>
          ) : null}
          <div className={`${'grid_wrapper'}`}>
            <div
              className={
                threeColumnView
                  ? 'col_l_12 col_m_12 padR32'
                  : `${'col_l_8 col_m_12 padR32'} ${s.rhs_border}`
              }
            >
              <div className={`${'grid_wrapper'}`}>
                {sectionData &&
                  sectionData.items &&
                  sectionData.items instanceof Array &&
                  sectionData.items.map((itemObj = {}) => {
                    const item = itemObj;
                    switch (item.tn) {
                      case 'lead_plus_vertical_list': {
                        return (
                          <div
                            className={
                              threeColumnView
                                ? `${'col_l_4 col_m_4'} ${s.linktypeHeight}`
                                : `${'col_l_3 col_m_3'} ${s.linktypeHeight}`
                            }
                          >
                            {item.name && (
                              <Listingheader
                                headingname={item.name}
                                headingLink={item.path}
                                size="small"
                                newga={`${sectionData.name}Section_Actions#${
                                  sectionData.name
                                }_HeadingClick-${item.name}`}
                                overrideClass={
                                  sectionData.id === 'popularacrosstoi'
                                    ? 'multiline'
                                    : ''
                                }
                                target={item.target}
                                ga4Type={
                                  item?.ga4Type
                                    ? item?.ga4Type
                                    : sectionData?.ga4Type
                                }
                                ga4Category={
                                  item?.ga4Category
                                    ? item?.ga4Category
                                    : sectionData?.ga4Category
                                }
                              />
                            )}
                            <CardListV5
                              data={item.items}
                              featuredItemDisplay={{
                                cssObj: {
                                  figureClass: [
                                    `${
                                      threeColumnView
                                        ? s.largefont
                                        : s.leadplusText
                                    }`,
                                  ],
                                  titleCont: s.fontBold,
                                },
                                featuredIndex: 0,
                                isVerticalTile: true,
                              }}
                              nonFeaturedDisplay={{
                                tileType: 'default',
                                listWrapperClass: `col_l_12 col_m_12`,
                                itemWrapperClass: 'bdr_bottom no_bdr_last',
                                cssObj: {},
                                itemClass: 'linktype2 mrgTB10',
                                hideImage: true,
                              }}
                              showDescription={false}
                              // newga={`${data.name}Section_Actions#${
                              //   data.name
                              // }Click-${data.name}/`}
                              imgWidth="500"
                              htmlKeys={item.htmlKeys}
                              newga={`${
                                sectionData.name
                              }Section_Actions#$typeClick-`}
                              key={`${sectionData.id}_${item.tn}`}
                              ga4Type={
                                item?.ga4Type
                                  ? item?.ga4Type
                                  : sectionData?.ga4Type
                              }
                              ga4Category={
                                item?.ga4Category
                                  ? item?.ga4Category
                                  : sectionData?.ga4Category
                              }
                            />
                          </div>
                        );
                      }

                      default: {
                        return null;
                      }
                    }
                  })}
              </div>
            </div>

            <div className={`${'col_l_4 hide_m padL32'}`}>
              {this.props.children}
            </div>
          </div>

          {sectionData.keywords &&
            sectionData.keywords.items && (
              <LinksList
                sectionData={sectionData.keywords}
                ga4Type={sectionData?.ga4Type}
                ga4Category={sectionData?.ga4Category}
              />
            )}
        </div>
      </>
    );
  }
}
RowLayoutWithVerticalColumns.propTypes = {
  sectionData: PropTypes.shape({}).isRequired,
  isWapView: PropTypes.bool,
  children: PropTypes.element,
  loadAjaxSectionData: PropTypes.func.isRequired,
  showCitySectionLoader: PropTypes.bool,
};

RowLayoutWithVerticalColumns.defaultProps = {
  isWapView: false,
  children: undefined,
  showCitySectionLoader: false,
};

export default RowLayoutWithVerticalColumns;
